import api from "Helpers/Api";

export default async function articleDelete(articleId: string) {
  const { data } = await api.delete(`/articles/delete/${articleId}`);

  return data;
}
